import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { NotificationService, ToastNotification } from './shared/services/notification.service';
import { ToastComponent } from './shared/toast/toast.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ToastComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly notification$: Observable<ToastNotification | null>;

  constructor(
    private readonly translate: TranslateService,
    private readonly notificationService: NotificationService,
  ) {
    this.notification$ = this.notificationService.notifications;
    const savedLang = localStorage.getItem('language') || 'en';
    translate.setDefaultLang('en');
    translate.use(savedLang);
  }
}
